export function getCachearticles ({ state, commit }, { search, page }) {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/v1/cachearticles', { params: { search, page } })
      .then((response) => {
        if (response.data.cachearticles) {
          commit('setCachearticles', response.data.cachearticles)
        }

        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function getCachearticle ({ state, commit }, cachearticleId) {
  return new Promise((resolve, reject) => {
    if (cachearticleId) {
      axiosInstance.get('/v1/cachearticles/' + cachearticleId)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No cachearticle id'))
    }
  })
}

export function deleteCachearticle ({ state, commit }, cachearticleId) {
  return new Promise((resolve, reject) => {
    if (cachearticleId) {
      axiosInstance.delete('/v1/cachearticles/' + cachearticleId)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No cachearticle id'))
    }
  })
}
